import React from 'react';
import { Container } from 'reactstrap';

import NotFoundImage from './not-found.png'

const NotFound = () => {
  return (
    <div className="not-found py-5">
      <Container>
        <p id="404-title" className="text-center not-found-title">Oops!</p>
        <p id="404-subtitle" className="text-center not-found-subtitle">This page isn't available</p>
        <p id="404-strap" className="text-center not-found-strap">The link you followed may be broken, or the page may have been removed.</p>
        <img id="404-image" className="not-found-image hidden-xs-down" alt="404 Not Found" src={NotFoundImage} />
      </Container>
    </div>
  );
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js